import EntityFormField from 'vue-forms/components/EntityFormField';

export default {
  mixins: [ EntityFormField ],

  props: {
    component: {
      default: 'role-input-field'
    },
  }
};
